import { IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Route, Switch } from "react-router";
import PortalContainer from "../../_+_Portal";
import SegundoFactorContainer from "_+_Portal/_-_SegundoFactor";

/**
 * Componente que maneja el router principal
 */
const RouterWithSession = () => {
  return (
    <IonReactRouter>
      <IonRouterOutlet>
        <Switch>
          <Route
            path={"/segundoFactor"}
            component={SegundoFactorContainer}
          />
          <Route path={"/"} component={PortalContainer} />
        </Switch>
      </IonRouterOutlet>
    </IonReactRouter>
  );
};

export default RouterWithSession;


